import { render, staticRenderFns } from "./goodsChange.vue?vue&type=template&id=77630940&scoped=true&"
import script from "./goodsChange.vue?vue&type=script&lang=js&"
export * from "./goodsChange.vue?vue&type=script&lang=js&"
import style0 from "./goodsChange.vue?vue&type=style&index=0&id=77630940&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77630940",
  null
  
)

component.options.__file = "goodsChange.vue"
export default component.exports